import { MessageCircle } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const communicatieManifest: ModuleDefinition = {
  id: 'communicatie',
  name: 'Communicatie',
  icon: <MessageCircle size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/communicatie',
  status: 'active',
  // v4: vier vaste tabs, de rest onder "Meer" (alle routes blijven bereikbaar).
  navItems: [
    { label: 'Inbox', path: '/communicatie', icon: '' },
    { label: 'Email', path: '/communicatie/email', icon: '' },
    { label: 'Berichten', path: '/communicatie/chat', icon: '', menu: 'meer' },
    { label: 'Dashboard', path: '/communicatie/dashboard', icon: '', menu: 'meer' },
    { label: 'Analytics', path: '/communicatie/analytics', icon: '', menu: 'meer' },
    { label: 'Campagnes', path: '/communicatie/campagnes', icon: '', menu: 'meer' },
    { label: 'Templates', path: '/communicatie/templates', icon: '', menu: 'meer' },
    { label: 'Zoeken', path: '/communicatie/zoeken', icon: '', menu: 'meer' },
    { label: 'Workflows', path: '/communicatie/workflows', icon: '', menu: 'meer' },
    { label: 'WhatsApp', path: '/communicatie/instellingen/whatsapp', icon: '', menu: 'meer' },
    { label: 'Chatbot', path: '/communicatie/instellingen/chatbot', icon: '', menu: 'meer' },
    { label: 'Feedback', path: '/communicatie/feedback', icon: '', menu: 'meer' },
    { label: 'Templates', path: '/communicatie/comm-templates', icon: '', menu: 'meer' },
    { label: 'Escalaties', path: '/communicatie/escalaties', icon: '', menu: 'meer' },
    { label: 'Audit', path: '/communicatie/audit', icon: '', menu: 'meer' },
  ],
  component: () => import('./index.js'),
};

export default communicatieManifest;
